<!-- BEGIN MODAL -->
<ng-template #contenido let-modal>
  <div class="modal-header">
      <h4 class="modal-title">{{ strTituloPantallaModal }}</h4>
      <button type="button" class="btn-close btn-rounded" data-bs-dismiss="modal" aria-label="Close"
          (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
      <app-upload (RetornoModal)=RetornoModal($event) [modalData]="modalData"></app-upload>
  </div>
</ng-template>
<!-- END MODAL -->

<div class="container-fluid mt-3 clasew">
  <div class="checkout-tabs">
      <div class="row gx-2 align-items-start">
          <div class="col-auto" style="padding: 0;">
              <ul ngbNav #navWizard="ngbNav" [activeId]="active" class="nav-pills flex-column"
                  (navChange)="tabChange($event)">
                  <li [ngbNavItem]="0">
                      <a ngbNavLink style="margin-top: 20px;margin-bottom: 20px;text-align: center; background: #f8f8fa;">
                          <h5 class="mb-1"><i class="fa fa-2xl fa-bars"></i></h5>
                      </a>
                  </li>
                  <li [ngbNavItem]="num+1" *ngFor="let item of navsData; index as num">
                    <ng-container *ngIf="(isStepper() ? num < 8 : num < 13); else hiddenNavLink">
                      
                      <ng-container *ngIf="!isStepper(); else stepperLink">
                        <a class="stepper-link" (click)="onStepperClick(num)" style="margin-bottom: 0px;text-align: center;">
                          <div [ngClass]="getStepNormalClass(num)" class="d-flex align-items-center">
                            <div class="step-icon">
                              <i class="fas {{getIcono(item)}} label-icon" placement="end" ngbTooltip="{{item.casilla}}"></i>
                            </div>
                            <div class="step-title" *ngIf="!tabsCollapsed; else tabsIconosSmall">{{item.casilla}}</div>
                            <ng-template #tabsIconosSmall></ng-template>
                          </div>
                        </a>
                      </ng-container>
                  
                     <!-- Stepper Horizontal -->
                     <ng-template #stepperLink>
                       <a class="stepper-link" (click)="onStepperClick(num)" style="margin-bottom: 0px;text-align: left;">
                         <div [ngClass]="getStepClass(num)" class="d-flex align-items-center">
                           <div class="step-number me-2">{{ (num+1) < 8 ? ('0' + (num+1)) : (num+1) }}</div>
                           <div class="step-title" *ngIf="!tabsCollapsed; else tabsIconosSmall">{{item.casilla}}</div>
                           <ng-template #tabsIconosSmall></ng-template>
                         </div>
                       </a>
                     </ng-template>
                   </ng-container>

                   <ng-template #hiddenNavLink></ng-template>

                      <ng-template ngbNavContent>
                        <div class="card mb-0">
                          <div class="card-body content-body" style="-webkit-overflow-scrolling: touch;">
                                  <div class="tab-content" id="v-pills-tabContent">
                                      <div class="tab-pane show active" id="v-pills-shipping" role="tabpanel"
                                          aria-labelledby="v-pills-shipping-tab ">
                                          <div *ngIf="num==0">
                                              <div class="row">
                                                  <div class="col-md-12">
                                                      <div class="navbar-header toolbar pt-1">
                                                          <div class="d-flex">
                                                            <div class="page-title-right">
                                                              <div class="breadcrumb-pro">
                                                                <ng-container *ngIf="data.length > 0">
                                                                  <div class="breadcrumb-pro-item">
                                                                    <i class="fas fa-layer-group breadcrumb-pro-icon"></i>
                                                                    <span>{{data[0].descripcion}}</span>
                                                                  </div>
                                                                  <i class="fas fa-chevron-right breadcrumb-pro-arrow"></i>
                                                                </ng-container>
                                                                <div class="breadcrumb-pro-item breadcrumb-pro-active">
                                                                  <span>{{titulo}}</span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div class="d-flex flex-wrap gap-2 align-items-center">
                                                              <!-- Botones visibles -->
                                                              <ng-container *ngFor="let boton of botonesVisibles">
                                                                <ng-container *ngTemplateOutlet="renderBoton; context: { $implicit: boton, isDropdown: false }"></ng-container>
                                                              </ng-container>

                                                              <!-- Dropdown Procesos -->
                                                              <div ngbDropdown *ngIf="botonesProcesos.length > 0" class="d-inline-block">
                                                                <button class="btn blanco btn-label waves-light" ngbDropdownToggle style="background-color: rgb(243, 164, 98);">
                                                                  <i class="fas fa-ellipsis-vertical label-icon me-2"></i> Procesos
                                                                </button>
                                                                <div ngbDropdownMenu>
                                                                  <ng-container *ngFor="let boton of botonesProcesos">
                                                                    <ng-container *ngTemplateOutlet="renderBoton; context: { $implicit: boton, isDropdown: true }"></ng-container>
                                                                  </ng-container>
                                                                </div>
                                                              </div>
                                                            
                                                              <!-- Dropdown Reportes -->
                                                              <div ngbDropdown *ngIf="botonesReportes.length > 0" class="d-inline-block">
                                                                <button class="btn blanco btn-label waves-light" ngbDropdownToggle style="background: #86aec4;">
                                                                  <i class="fas fa-print label-icon me-2"></i> Reportes
                                                                </button>
                                                                <div ngbDropdownMenu>
                                                                  <ng-container *ngFor="let boton of botonesReportes">
                                                                    <ng-container *ngTemplateOutlet="renderBoton; context: { $implicit: boton, isDropdown: true }"></ng-container>
                                                                  </ng-container>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            
                                                            <!-- Template genérico para botones -->
                                                            <ng-template #renderBoton let-boton let-isDropdown="isDropdown">
                                                              <!-- Botón imprimir con submenú -->
                                                              <ng-container *ngIf="boton.Evento === 'IMPRIMIR'; else normalButton">
                                                                <ng-container *ngIf="!isDropdown; else imprimirEnDropdown">
                                                                  <!-- Versión normal con submenú -->
                                                                  <div ngbDropdown class="d-inline-block">
                                                                    <button
                                                                      type="button"
                                                                      class="btn blanco btn-label waves-light"
                                                                      ngbDropdownToggle
                                                                      title="{{ boton.Tooltip }}"
                                                                      [ngStyle]="{ 'background-color': boton.class }"
                                                                    
                                                                    >
                                                                      <i class="fas {{ boton.icono }} label-icon me-2"></i> {{ boton.boton }}
                                                                    </button>
                                                                    <div ngbDropdownMenu>
                                                                      <button
                                                                        ngbDropdownItem
                                                                        (click)="EventoClickMS($event, boton.URL, boton.Evento, contenido, boton, 'PDF')"
                                                                      
                                                                      >
                                                                        <i class="fas fa-file-pdf me-2 text-danger"></i> Ver en PDF
                                                                      </button>
                                                                      <button
                                                                        ngbDropdownItem
                                                                        (click)="EventoClickMS($event, boton.URL, boton.Evento, contenido, boton, 'XLS')"
                                                                      
                                                                      >
                                                                        <i class="fas fa-file-excel me-2 text-success"></i> Descargar Excel
                                                                      </button>
                                                                    </div>
                                                                  </div>
                                                                </ng-container>
                                                              </ng-container>
                                                            
                                                              <!-- Botón imprimir dentro de dropdown -->
                                                              <ng-template #imprimirEnDropdown>
                                                                <button
                                                                  class="dropdown-item"
                                                                  (click)="abrirSelectorFormato(boton)"
                                                                
                                                                >
                                                                  <i class="fas {{ boton.icono }} me-2"></i> {{ boton.boton }}
                                                                </button>
                                                              </ng-template>
                                                            
                                                              <!-- Botón común -->
                                                              <ng-template #normalButton>
                                                                <button
                                                                  type="button"
                                                                  [ngClass]="{
                                                                    'btn blanco btn-label waves-light': !isDropdown,
                                                                    'dropdown-item': isDropdown
                                                                  }"
                                                                  [ngStyle]="!isDropdown ? { 'background-color': boton.class } : {}"
                                                                  (click)="EventoClickMS($event, boton.URL, boton.Evento, contenido, boton, '')"
                                                                
                                                                >
                                                                  <i class="fas {{ boton.icono }} label-icon me-2"></i> {{ boton.boton }}
                                                                </button>
                                                              </ng-template>
                                                              
                                                            </ng-template>
                                                          </div>
                                                  </div>
                                              </div>
                                              <!-- END Toolbar -->

                                              <!-- END BUTTONS -->

                                              <app-board [SYS02CON]="this.SYS02CON"></app-board>

                                              <app-alerta [SYS41ARC]="this.SYS41ARC"></app-alerta>

                                              <app-campo [SYS02JAV]="this.SYS02JAV" 
                                                  [strModoCampo]="this.strModoCampo"  
                                                  [WsLlaves]="this.WsLlaves" 
                                                  [FormID]="this.FormID"
                                                  [SYS02CON]="this.SYS02CON"
                                                  [AccionesOnChange]="this.AccionesOnChange"
                                                  [form_template]="retornaObservable(form_template) | async">
                                              </app-campo>

                                              <div id="buttons">
                                                  <!-- BEGIN Toolbar -->
                                                  <div class="row">
                                                      <div class="col-12">
                                                          <div class="navbar-header toolbar pb-1">
                                                              <div class="d-flex">
                                                                  <div>
                                                                      <label>[{{this.SYS02CON}}]</label>
                                                                  </div>
                                                              </div>
                                                              <div class="d-flex flex-wrap gap-2 align-items-center">
                                                                  <!-- Botones visibles -->
                                                                  <ng-container *ngFor="let boton of botonesVisibles">
                                                                    <ng-container *ngTemplateOutlet="renderBoton; context: { $implicit: boton, isDropdown: false }"></ng-container>
                                                                  </ng-container>
                                                                
                                                                  <!-- Dropdown Procesos -->
                                                                  <div
                                                                    ngbDropdown
                                                                    *ngIf="botonesProcesos.length > 0"
                                                                    class="d-inline-block"
                                                                    container="body"
                                                                    placement="top-end"
                                                                    >
                                                                    <button
                                                                      class="btn blanco btn-label waves-light"
                                                                      ngbDropdownToggle
                                                                      style="background-color: rgb(243, 164, 98); "
                                                                    >
                                                                      <i class="fas fa-ellipsis-vertical label-icon me-2"></i> Procesos
                                                                    </button>
                                                                    <div ngbDropdownMenu>
                                                                      <ng-container *ngFor="let boton of botonesProcesos">
                                                                        <ng-container
                                                                          *ngTemplateOutlet="renderBoton; context: { $implicit: boton, isDropdown: true }"
                                                                        ></ng-container>
                                                                      </ng-container>
                                                                    </div>
                                                                  </div>

                                                                  <!-- Dropdown Reportes -->
                                                                  <div
                                                                    ngbDropdown
                                                                    *ngIf="botonesReportes.length > 0"
                                                                    class="d-inline-block"
                                                                    container="body"
                                                                    placement="top-end"
                                                                    >
                                                                    <button
                                                                      class="btn blanco btn-label waves-light"
                                                                      ngbDropdownToggle
                                                                      style="background: #86aec4;"
                                                                    >
                                                                      <i class="fas fa-print label-icon me-2"></i> Reportes
                                                                    </button>
                                                                    <div ngbDropdownMenu>
                                                                      <ng-container *ngFor="let boton of botonesReportes">
                                                                        <ng-container
                                                                          *ngTemplateOutlet="renderBoton; context: { $implicit: boton, isDropdown: true }"
                                                                        ></ng-container>
                                                                      </ng-container>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                
                                                                <!-- Template genérico para botones -->
                                                                <ng-template #renderBoton let-boton let-isDropdown="isDropdown">
                                                                  <!-- Botón imprimir con submenú -->
                                                                  <ng-container *ngIf="boton.Evento === 'IMPRIMIR'; else normalButton">
                                                                    <ng-container *ngIf="!isDropdown; else imprimirEnDropdown">
                                                                      <!-- Versión normal con submenú -->
                                                                      <div
                                                                        ngbDropdown
                                                                        class="d-inline-block"
                                                                        container="body"
                                                                        placement="top-end"
                                                                      >
                                                                        <button
                                                                          type="button"
                                                                          class="btn blanco btn-label waves-light"
                                                                          ngbDropdownToggle
                                                                          title="{{ boton.Tooltip }}"
                                                                          [ngStyle]="{ 'background-color': boton.class }"
                                                                        >
                                                                          <i class="fas {{ boton.icono }} label-icon me-2"></i>
                                                                          {{ boton.boton }}
                                                                        </button>
                                                                        <div ngbDropdownMenu>
                                                                          <button
                                                                            ngbDropdownItem
                                                                            (click)="EventoClickMS($event, boton.URL, boton.Evento, contenido, boton, 'PDF')"
                                                                          >
                                                                            <i class="fas fa-file-pdf me-2 text-danger"></i> Ver en PDF
                                                                          </button>
                                                                          <button
                                                                            ngbDropdownItem
                                                                            (click)="EventoClickMS($event, boton.URL, boton.Evento, contenido, boton, 'XLS')"
                                                                          >
                                                                            <i class="fas fa-file-excel me-2 text-success"></i> Descargar Excel
                                                                          </button>
                                                                        </div>
                                                                      </div>
                                                                    </ng-container>
                                                                  </ng-container>
                                                                
                                                                  <!-- Botón imprimir dentro de dropdown -->
                                                                  <ng-template #imprimirEnDropdown>
                                                                    <button
                                                                      class="dropdown-item"
                                                                      (click)="abrirSelectorFormato(boton)"
                                                                    >
                                                                      <i class="fas {{ boton.icono }} me-2"></i> {{ boton.boton }}
                                                                    </button>
                                                                  </ng-template>
                                                                
                                                                  <!-- Botón común -->
                                                                  <ng-template #normalButton>
                                                                    <button
                                                                      type="button"
                                                                      class="btn blanco btn-label waves-light"
                                                                      [ngStyle]="{ 'background-color': boton.class }"
                                                                      [class.dropdown-item]="isDropdown"
                                                                      (click)="EventoClickMS($event, boton.URL, boton.Evento, contenido, boton, '')"
                                                                    >
                                                                      <i class="fas {{ boton.icono }} label-icon me-2"></i> {{ boton.boton }}
                                                                    </button>
                                                                  </ng-template>
                                                                </ng-template>  
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <!-- END Toolbar -->
                                              </div>
                                              <!-- END BUTTONS -->
                                          </div>

                                          <ng-container *ngIf="num > 0">
                                              <ng-container *ngIf="item.SYS02TIP == 'HOR'">
                                                <app-horarios
                                                    [WsURL]="item.url"
                                                    [WsLlaves]="item.Llaves"
                                                    [MsDetalle]="item.MsDetalle"
                                                    [A04CDE]="titulo"
                                                    [WORKFLOW]="item.WORKFLOW"
                                                    [DOC10ARC]="item.DOC10ARC"
                                                    [PRO10ARC]="item.PRO10ARC"
                                                    [strSYS02TIP]="item.SYS02TIP"
                                                    [SYS02CON_PAPA_LD]="this.SYS02CON"
                                                    (AbrirNuevoNav)="AbrirNuevoNavInterno($event)">
                                                </app-horarios>
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='TED'">
                                                  <app-advancetable-editable
                                                      [breadCrumbItems]="breadCrumbItems"
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves"
                                                      [A04CDE]="titulo"
                                                      [SYS02CON_PAPA_LD]="this.SYS02CON"
                                                      (AbrirNuevoNav)="AbrirNuevoNavInterno($event)">
                                                  </app-advancetable-editable>
                                              </ng-container>
                                              
                                              <ng-container  *ngIf="item.SYS02TIP =='LST'">
                                                  <app-advancedtable
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves"
                                                      [MsDetalle]="item.MsDetalle"
                                                      [A04CDE]="titulo"
                                                      [WORKFLOW]="item.WORKFLOW"
                                                      [DOC10ARC]="item.DOC10ARC"
                                                      [PRO10ARC]="item.PRO10ARC"
                                                      [SYS02CON_PAPA_LD]="this.SYS02CON"
                                                      (AbrirNuevoNav)="AbrirNuevoNavInterno($event)">
                                                  </app-advancedtable>
                                              </ng-container>

                                              <ng-container *ngIf="item.SYS02TIP == 'CAL'">
                                                  <app-advancedtable
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves"
                                                      [MsDetalle]="item.MsDetalle"
                                                      [A04CDE]="titulo"
                                                      [WORKFLOW]="item.WORKFLOW"
                                                      [DOC10ARC]="item.DOC10ARC"
                                                      [PRO10ARC]="item.PRO10ARC"
                                                      [strSYS02TIP]="item.SYS02TIP"
                                                      [SYS02CON_PAPA_LD]="this.SYS02CON"
                                                      (AbrirNuevoNav)="AbrirNuevoNavInterno($event)">
                                                  </app-advancedtable>
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='MS'">
                                                  <app-simple-ms 
                                                      [WsData]=GenerarJSONMantenimiento(item)
                                                      (CerrarMsInterno)="CerrarMantenimiento()"
                                                      [Origen]="'Wizard'">    
                                                  </app-simple-ms>
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='RPT'">
                                                  <report-viewer 
                                                      [strRptUrl]= "item.url"
                                                      [Llaves]="item.Llaves"
                                                      [tipoDocumento]="'data:application/pdf'"></report-viewer>
                                              </ng-container>

                      <ng-container  *ngIf="item.SYS02TIP =='LES' || item.SYS02TIP =='LSN'">
                                                  <!-- LES = Tabla Syncfusion Editable // LSN = Tabla Syncfusion No Editable (abre Manteimiento) -->
                                                  <app-lista-editable-sync
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves"
                                                      [MsDetalle]="item.MsDetalle"
                                                      [A04CDE]="titulo"
                                                      [WORKFLOW]="item.WORKFLOW"
                                                      [DOC10ARC]="item.DOC10ARC"
                                                      [PRO10ARC]="item.PRO10ARC"
                                                      [SYS02CON_PAPA_LD]="this.SYS02CON"
                                                      [SYS02TIP]="item.SYS02TIP"
                                                      (AbrirNuevoNav)="AbrirNuevoNavInterno($event)">
                                                  </app-lista-editable-sync>                                                    
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='LCD'">
                                                  <app-lista-cards
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves">
                                                  </app-lista-cards>
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='STP'">
                                                  <app-stepper
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves"
                                                      [EventoCerrarMSNavID]="EventoCerrarMSNavID"
                                                      Tipo="Encuesta">
                                                  </app-stepper>                                                    
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='STT'">
                                                  <app-stepper
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves"
                                                      [EventoCerrarMSNavID]="EventoCerrarMSNavID"
                                                      Tipo="Test">
                                                  </app-stepper>                                                    
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='STA'">
                                                  <app-stepper
                                                      [WsURL]="item.url"
                                                      [WsLlaves]="item.Llaves"
                                                      [EventoCerrarMSNavID]="EventoCerrarMSNavID"
                                                      Tipo="Aplicada"> 
                                                  </app-stepper>                                                    
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='NTS'">
                                                  <app-serviciodocente-notas
                                                      [WsLlaves]="item.Llaves">
                                                  </app-serviciodocente-notas>
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='AUS'">
                                                  <app-ausencias
                                                      [WsLlaves]="item.Llaves">
                                                  </app-ausencias>
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='HRS'">
                                                  <app-marcajes-quincena
                                                      [WsLlaves]="item.Llaves">
                                                  </app-marcajes-quincena>
                                              </ng-container>

                                              <ng-container  *ngIf="item.SYS02TIP =='KBN'">
                                                  <app-pro-board
                                                    [WsLlaves]="item.Llaves">
                                                  </app-pro-board>
                                              </ng-container>

                                                <ng-container  *ngIf="item.SYS02TIP =='MAP'">
													                        <app-mapeo-registros
                                                      [strWsURL]="item.url"
                                                      [strSYS02TIP]="item.SYS02TIP"
                                                      [llaves]="item.Llaves">
                                                      [strSYS02TIP]=item.SYS02TIP>
													                        </app-mapeo-registros>
                                                </ng-container>
                                          </ng-container>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </ng-template>
                  </li>
                  <!-- BOTÓN MAS OPCIONES -->
                  <li *ngIf="navsData?.length > (isStepper() ? 8 : 13)" class="nav-item position-relative">
                    <a #ellipsisBtn class="stepper-link" (click)="toggleFloatingPanel($event)" style="cursor: pointer; text-align: center;">
                      <div [ngClass]="{ 'step-card': true, 'step-active': showFloatingPanel }" class="d-flex align-items-center justify-content-center" style="margin-bottom: 0px;">
                        <div class="step-icon d-flex flex-column align-items-center" style="font-size: 10px; gap: 2px;">
                          <i *ngIf="tabsCollapsed" class="label-icon" [ngClass]="showFloatingPanel ? 'fas fa-times' : 'fas fa-grip-vertical'" ngbTooltip="Más Opciones"></i>
                          <span *ngIf="!tabsCollapsed" style="font-size: 9px; line-height: 1;">Más Opciones</span>
                        </div>
                      </div>
                    </a>
                    <div class="floating-backdrop" *ngIf="showFloatingPanel" (click)="closeFloatingPanel()"></div>
                    <div #floatingPanel class="seccion-flotante-tabs" *ngIf="showFloatingPanel" role="menu" aria-label="Más opciones" (click)="$event.stopPropagation()">
                      <div class="flotante-header">
                        <i class="fas fa-list-ul me-2"></i> Más Opciones
                      </div>
                      <div class="flotante-body">
                        <ng-container *ngFor="let item of navsData; let idx = index">
                          <div class="flotante-item"
                               *ngIf="idx >= (isStepper() ? 8 : 13)"
                               [class.active]="active === (idx + 1)"
                               (click)="onFloatingTabClick(idx)">
                            <div class="d-flex align-items-center w-100">
                              <i class="fas {{getIcono(item)}} me-3 icon-fixed"></i>
                              <span class="text-truncate">{{ item.casilla }}</span>
                              <i class="fas fa-check ms-auto small-icon" *ngIf="active === (idx + 1)"></i>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </li>
              </ul>

              <div *ngIf="isStepper()" class="stepper-mini d-flex flex-column align-items-center" aria-hidden="false">
                <button
                  type="button"
                  class="btn btn-stepper btn-prev"
                  [disabled]="active === 1"
                  (click)="retrocederStep()"
                  title="Anterior"
                  aria-label="Anterior"
                >
                  <i class="fas fa-chevron-left"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-stepper btn-next"
                  [disabled]="active >= navsData.length + 1"
                  (click)="avanzarStep()"
                  title="Siguiente"
                  aria-label="Siguiente"
                >
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
              <!-- </div>
              </div> -->
          </div>
          <div class="col content-col" #wiz>
              <div [ngbNavOutlet]="navWizard"></div>
          </div>
          <div [ngClass]="isCollapsed ? 'col-auto':'col-2'" [style.max-height]="alturaSidebar"
              style="overflow-y: auto; overflow-x: hidden;" *ngIf="sidebar != '' || encabezado?.length > 0">
              <sidebar-avatar [url]="sidebar" [templates]="form_template" [encabezado]="encabezado" 
              [operaciones]="ToolbarMS" [llaves]="WsLlaves" [encabezadoSYS02CON]="SYS02CON"
                  (toggle)="toggleSidebar($event)" (actualizar)="cerrarWizard()"></sidebar-avatar>
          </div>
      </div>
  </div>
</div>
<app-scroll-to-top>
</app-scroll-to-top>
